<template>
    <div class="BoxList">
        <slot />
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from 'vue-property-decorator';

    @Component
    export default class BoxList extends Vue {
    }
</script>
